import React, { useEffect, useState } from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  ChipField,
  Datagrid,
  Edit,
  List,
  NumberField,
  Pagination,
  ReferenceArrayField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  SingleFieldList,
  Tab,
  TabbedShowLayout,
  TextField,
  BooleanField,
  TextInput,
  TopToolbar,
  useRecordContext,
  EditButton,
  useGetIdentity,
  useDataProvider,
} from 'react-admin';
import { useNotify, useRefresh, useUpdate } from 'react-admin';
import { gql, useMutation } from "@apollo/react-hooks";

import {  DialogActions } from '@material-ui/core'; // Use @material-ui/core for MUI v4

import { Link, useParams } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Snackbar from '@material-ui/core/Snackbar';
import { analyticsTrackEvent } from '../utils/segment';
import { getEnv } from "../utils/getEnv";

import { CircularProgress, Typography } from "@material-ui/core";

const CustomPagination = props => {
  return (
    <Pagination {...props} rowsPerPageOptions={[10, 25, 50, 100]} />
  );
};

const SET_PROJECT_COMPLETE = gql`
    mutation SetProjectComplete($input: SetProjectCompleteInput!) {
        setProjectComplete(input: $input) {
            id
        }
    }
`;

const IsCompleteField = ({ source, record = {}, companyId }) => {
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const [setProjectComplete, { loading }] = useMutation(SET_PROJECT_COMPLETE);

  const isComplete = record[source];

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent rowClick from being triggered
    setOpen(true);
  };

  const handleClose = (event) => {
    event.stopPropagation(); // Prevent rowClick from being triggered
    setOpen(false);
  };

  const handleSave = async (event) => {
    event.stopPropagation(); // Prevent rowClick from being triggered
    try {
      await setProjectComplete({
        variables: {
          input: {
            projectId: record.id,
            companyId: Number(companyId),
            isComplete: !isComplete,
          },
        },
      });
      notify('Project completion status updated', 'info');
      refresh();
      setOpen(false);
    } catch (error) {
      notify(`Error: ${error.message}`, 'warning');
    }
  };

  return (
    <>
      <span onClick={handleClick} style={{cursor: 'pointer'}}>
          <BooleanField source={source} record={record}/>
      </span>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Update project completion</DialogTitle>
        <DialogContent>
          <p>Set this project to { isComplete ? 'incomplete' : 'complete'}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" disabled={loading}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
const companySearch = (n) => {
  if (n && n.length > 2) {
    return {
      name__like: n,
    }
  }
}

const companyFilters = [
  <TextInput source="name__like" label="Name" alwaysOn />,
  <SelectInput
    choices={[
      { id: 'Aluminium and Glass Facades', name: 'Aluminium and Glass Facades' },
      { id: 'Australia - NSW/ACT', name: 'Australia - NSW/ACT' },
      { id: 'Australia - QLD', name: 'Australia - QLD' },
      { id: 'Australia - TA', name: 'Australia - TA' },
      { id: 'Australia - VIC', name: 'Australia - VIC' },
      { id: 'Australia - WA', name: 'Australia - WA' },
      { id: 'Australia Wide', name: 'Australia Wide' },
      { id: 'China', name: 'China' },
      { id: 'NZ', name: 'NZ' },
      { id: 'Other', name: 'Other' },
      { id: 'UK', name: 'UK' },
      { id: 'USA', name: 'USA' },
    ]}
    source="location"
    label="Location"
  />,
  <SelectInput
    choices={[
      { id: 'Aluminium and Glass Facades', name: 'Aluminium and Glass Facades' },
      { id: 'ALUMINIUM DOORS AND WINDOWS', name: 'ALUMINIUM DOORS AND WINDOWS' },
      { id: 'Aluminium Window Fitter / Glazing', name: 'Aluminium Window Fitter / Glazing' },
      { id: 'Balustrades', name: 'Balustrades' },
      { id: 'Benchtops and Tiling', name: 'Benchtops and Tiling' },
      { id: 'Builder', name: 'Builder' },
      { id: 'Carpentry & Pod Install', name: 'Carpentry & Pod Install' },
      { id: 'Caulking', name: 'Caulking' },
      { id: 'Doors', name: 'Doors' },
      { id: 'Dry Fire', name: 'Dry Fire' },
      { id: 'Electrical', name: 'Electrical' },
      { id: 'Facade', name: 'Facade' },
      { id: 'Facade Installation', name: 'Facade Installation' },
      { id: 'Fire', name: 'Fire' },
      { id: 'Flooring', name: 'Flooring' },
      { id: 'GC', name: 'GC' },
      { id: 'Hydraulic', name: 'Hydraulic' },
      { id: 'Joinery, Stone, Fix', name: 'Joinery, Stone, Fix' },
      { id: 'Louvres', name: 'Louvres' },
      { id: 'Mechanical', name: 'Mechanical' },
      { id: 'Metal Processing', name: 'Metal Processing' },
      { id: 'Painter', name: 'Painter' },
      { id: 'Painting', name: 'Painting' },
      { id: 'Plaster', name: 'Plaster' },
      { id: 'Plumbers', name: 'Plumbers' },
      { id: 'Plumbing', name: 'Plumbing' },
      { id: 'QA/QC', name: 'QA/QC' },
      { id: 'Sanitary Supplier', name: 'Sanitary Supplier' },
      { id: 'Stone and Tiling', name: 'Stone and Tiling' },
      { id: 'Structural Steel', name: 'Structural Steel' },
      { id: 'Waterproofing', name: 'Waterproofing' },
      { id: 'Wet Fire', name: 'Wet Fire' },
      { id: 'Windows and Facades', name: 'Windows and Facades' },
    ]}
    source="company_trade"
    label="Trade"
  />,
  <SelectInput
    choices={[
      { id: 'Builder', name: 'Builder' },
      { id: 'Developer', name: 'Developer' },
      { id: 'Installer', name: 'Installer' },
      { id: 'Logistics', name: 'Logistics' },
      { id: 'Manufacturer', name: 'Manufacturer' },
      { id: 'Other', name: 'Other' },
      { id: 'QA/QC', name: 'QA/QC' },
      { id: 'Supplier', name: 'Supplier' },
    ]}
    source="type"
    label="Type"
  />,
  <ReferenceInput label="Is on Project" source="project_id" reference="Project" filterToQuery={companySearch} perPage={1000} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <BooleanInput source="useBillingFilter" label="Item limit exceeded" />,

];
const DELETE_COMPANY = gql`
  mutation deleteCompany($id: Int!) {
    deleteCompanyWithNoUserProject(id: $id)
}
`;

const BulkDeleteButton = ({ selectedIds, filterValues, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [errorMessageOpen, setErrorMessageOpen] = useState(false);
  const [deleteCompnay] = useMutation(DELETE_COMPANY, {
    variables: {
      id: selectedIds[0]
    },
    onError:(err)=>{
      setErrorMessageOpen(true)
      setOpen(false)
    },
    onCompleted:()=>{
      setOpen(false)
      window.location.reload();
    }
  });
  const handleDialogClose = () => {
    setOpen(false);
  }
  if(selectedIds.length > 1){
    return <Button disabled />
  }


  function handleClick() {
    setOpen(true)
  }
  const handleDelete= async()=> {
    const deleteConfirm = window.confirm('Comfirm delete company?')
    if (deleteConfirm) {
        deleteCompnay();
    }
  }
  return (
    <>
    <Button
    variant="contained"
    size="small"
    color="primary"
    style={{ marginRight: "8px" }}
      onClick={handleClick}
    >Delete</Button>
    <Snackbar open={errorMessageOpen} autoHideDuration={6000} onClose={()=>setErrorMessageOpen(false)} message='Delete company failed' />
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Company Details</DialogTitle>
      <DialogContent>
          <DialogContentText>
          Delete company can only delete company with no user or project (except Example Project), Please check if company still has project or user.
          </DialogContentText>
          <Button 
            variant="contained"
            size="small"
            color="primary" 
            onClick={handleDelete} >
              Delete
          </Button>
      </DialogContent>
    </Dialog>
    </>
  )
};

const CompanyBulkActionButtons = props => {
  return (
    <>
      <BulkDeleteButton {...props} />
    </>
  );
};

const ProjectsField = ({ record }) => {
  if (!record || record.projectsIds.length > 50) {
    return <span>Too many projects to display</span>; // or you could return null
  }

  return (
    <ReferenceArrayField label="Projects" reference="Project" source="projectsIds" record={record}>
      <SingleFieldList link="show">
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

const env = getEnv();

const StripeCustomerLinkField = ({ record }) => {
  const stripeId = record.stripe_id;
  if (!stripeId) return null;
  const isProd = env === 'prod';
  const stripeDashboardUrl = `https://dashboard.stripe.com${isProd ? '' : '/test'}/customers/${stripeId}`;

  return (
    <a onClick={e => e.stopPropagation()} href={stripeDashboardUrl} target="_blank" rel="noopener">
      {stripeId}
    </a>
  );
};


const NestedTextField = ({ source, record = {} }) => {
  const value = source.split('.').reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : null, record);
  return <span>{value || 'N/A'}</span>;
};

export const CompanyList = props => {
  return (
    <List {...props} bulkActionButtons={<CompanyBulkActionButtons />} filters={companyFilters} pagination={<CustomPagination />}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="name" label="Name" />
        <TextField source="company_trade" label="Trade" />
        <TextField source="type" label="Type" />
        <TextField source="location" label="Location" />
        <ReferenceArrayField label="Projects" reference="Project" source="projectsIds">
          <SingleFieldList link="show">
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
        <NumberField source="totalBillableRecords" label="Billable records" />
        <NumberField source="totalCollaborators" label="Collaborators" />
        <StripeCustomerLinkField source="stripe_id" label="Stripe ID" />
        <NestedTextField source="stripeUsageLimits.items" />

        <BooleanField source="billingEnforced" label="Billing enforced" valueLabelTrue="Enabled" valueLabelFalse="Disabled"  />

        {/*<ArrayField source="reportTemplates"><SingleFieldList><ChipField source="id" /></SingleFieldList></ArrayField>*/}
        {/*<ReferenceArrayField source="reportTemplatesIds" reference="reportTemplates"><TextField source="id" /></ReferenceArrayField>*/}
        {/*<TextField source="updated_at" />*/}
        {/*<NumberField source="auto_approve" />*/}
      </Datagrid>
    </List>
  );
}

const CompanyTitle = ({ record }) => {
  return <span>Company{record ? `: ${record.name}` : ''}</span>;
};


const LinkToCompanyUsers = () => {
  const record = useRecordContext();
  return record ? (
    <Button
      color="primary"
      variant="contained"
      component={Link}
      to={{
        pathname: '/User',
        search: `filter=${JSON.stringify({ company_id: record.id })}`,
      }}
    >
      Company Users
    </Button>
  ) : null;
};

const CompanyShowActions = ({ basePath, data, record }) => (
  <TopToolbar>
    <LinkToCompanyUsers/>
    <EditButton basePath={basePath} label="Edit" record={data} />
  </TopToolbar>
);

const CustomBooleanField2 = ({ source, label }) => {
  const record = useRecordContext();
  return record ? (
    <div>
      <strong>{label}: </strong>{record[source] === true ? 'Enabled' : 'Disabled'}
    </div>
  ) : null;
};
export const CompanyShow = (props) => (
  <Show title={<CompanyTitle />} {...props} actions={<CompanyShowActions/>}>
    <TabbedShowLayout syncWithLocation={false}>
      <Tab label="summary">
        <SimpleShowLayout>
          <ReferenceArrayField label="Company's Projects" reference="Project" source="projectsIds">
            <SingleFieldList link="show">
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
          <TextField source="id" />
          <TextField source="name" label="Name" />
          <TextField source="company_trade" label="Trade" />
          <TextField source="type" label="Type" />
          <TextField source="location" label="Location" />
          <TextField source="contact_name" label="Contact Name" />
          <TextField source="contact_phone" label="Contact Phone" />
          <TextField source="contact_email" label="Contact Email" />
          <TextField source="acn" label="ACN" />
          <TextField source="created_at" label="Created At" />
          <TextField source="stripe_id" label="Stripe ID" />

          <BooleanField source="billingEnforced" label="Billing enforced" valueLabelTrue="Enabled" valueLabelFalse="Disabled"  />

        </SimpleShowLayout>
      </Tab>
      <Tab label="Projects">
        <ReferenceArrayField label="Projects" reference="Project" source="projectsIds">
          <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="name" /> 
            <TextField source="classification" />
            <TextField source="totalBillableRecords" />
            <TextField source="totalCollaborators" />

            <IsCompleteField source="isComplete" companyId={props.id} />
            <ReferenceArrayField label="Company" reference="Company" source="companiesIds">
              <SingleFieldList link="show">
                <ChipField source="name" />
              </SingleFieldList>
            </ReferenceArrayField>
          </Datagrid>
        </ReferenceArrayField>
      </Tab>
      <Tab label="Groups">
        <ReferenceArrayField label="Groups" reference="Group" source="groupsIds">
          <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="name" label="Name" />
            <TextField source="is_default" label="Default" />
            <ReferenceField reference="Project" source="project.id" link="show" label='Project'>
              <TextField source="name" />
            </ReferenceField>
          </Datagrid>
        </ReferenceArrayField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

const onCompanyEditSuccess = (update) => {
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const userName = currentUser.username;
  const data = {
    companyId: update.id,
    companyName: update.name,
    companyContactEmail: update.contact_email,
    companyLocation: update.location,
    companyType: update.type,
    companyTrade: update.company_trade,
    companyContactPhone: update.contact_phone,
    companyACN: update.acn,
    updatedBy: userName,
  }
  analyticsTrackEvent("Company Info Updated", "Company", data);
}

export const CompanyEditView = (props) => {
  return (
    <Edit title="Edit Company" 
      {...props} 
      undoable={false} 
      onSuccess={({data}) => {
        onCompanyEditSuccess(data)
      }}
    >
      <SimpleForm>
        <TextInput disabled source="id" />
        <TextInput source="name" />
        <TextInput source="acn" />
        <TextInput source="contact_name" />
        <TextInput source="contact_phone" />
        <TextInput source="contact_email" />
        <SelectInput
          choices={[
            { id: "Aluminium and Glass Facades", name: "Aluminium and Glass Facades" },
            { id: "Australia - NSW/ACT", name: "Australia - NSW/ACT" },
            { id: "Australia - QLD", name: "Australia - QLD" },
            { id: "Australia - TA", name: "Australia - TA" },
            { id: "Australia - VIC", name: "Australia - VIC" },
            { id: "Australia - WA", name: "Australia - WA" },
            { id: "Australia Wide", name: "Australia Wide" },
            { id: "China", name: "China" },
            { id: "NZ", name: "NZ" },
            { id: "Other", name: "Other" },
            { id: "UK", name: "UK" },
            { id: "USA", name: "USA" },
          ]}
          source="location"
          label="Location"
        />
        <SelectInput
          choices={[
            { id: "Aluminium and Glass Facades", name: "Aluminium and Glass Facades" },
            { id: "ALUMINIUM DOORS AND WINDOWS", name: "ALUMINIUM DOORS AND WINDOWS" },
            { id: "Aluminium Window Fitter / Glazing", name: "Aluminium Window Fitter / Glazing" },
            { id: "Balustrades", name: "Balustrades" },
            { id: "Benchtops and Tiling", name: "Benchtops and Tiling" },
            { id: "Builder", name: "Builder" },
            { id: "Carpentry & Pod Install", name: "Carpentry & Pod Install" },
            { id: "Caulking", name: "Caulking" },
            { id: "Doors", name: "Doors" },
            { id: "Dry Fire", name: "Dry Fire" },
            { id: "Electrical", name: "Electrical" },
            { id: "Facade", name: "Facade" },
            { id: "Facade Installation", name: "Facade Installation" },
            { id: "Fire", name: "Fire" },
            { id: "Flooring", name: "Flooring" },
            { id: "GC", name: "GC" },
            { id: "Hydraulic", name: "Hydraulic" },
            { id: "Joinery, Stone, Fix", name: "Joinery, Stone, Fix" },
            { id: "Louvres", name: "Louvres" },
            { id: "Mechanical", name: "Mechanical" },
            { id: "Metal Processing", name: "Metal Processing" },
            { id: "Painter", name: "Painter" },
            { id: "Painting", name: "Painting" },
            { id: "Plaster", name: "Plaster" },
            { id: "Plumbers", name: "Plumbers" },
            { id: "Plumbing", name: "Plumbing" },
            { id: "QA/QC", name: "QA/QC" },
            { id: "Sanitary Supplier", name: "Sanitary Supplier" },
            { id: "Stone and Tiling", name: "Stone and Tiling" },
            { id: "Structural Steel", name: "Structural Steel" },
            { id: "Waterproofing", name: "Waterproofing" },
            { id: "Wet Fire", name: "Wet Fire" },
            { id: "Windows and Facades", name: "Windows and Facades" },
          ]}
          source="company_trade"
          label="Trade"
        />
        <SelectInput
          choices={[
            { id: "Builder", name: "Builder" },
            { id: "Developer", name: "Developer" },
            { id: "Installer", name: "Installer" },
            { id: "Logistics", name: "Logistics" },
            { id: "Manufacturer", name: "Manufacturer" },
            { id: "Other", name: "Other" },
            { id: "QA/QC", name: "QA/QC" },
            { id: "Supplier", name: "Supplier" },
          ]}
          source="type"
          label="Type"
        />
        <BooleanInput source="auto_approve" />
        <TextInput source="stripe_id" />
        <BooleanInput source="billingEnforced" />
      </SimpleForm>
    </Edit>
  );
};
